import store from './store'

export default {
    login(context, payload) {
        context.commit('LOGIN', payload);
    },
    requests(context, start) {
        context.commit('REQUESTS', start);
    },
    namespace(context, payload) {
        if (payload.namespace) {
            let namespace = payload.namespace;
            delete payload.namespace;

            let finalPath = {}
            let path = finalPath;
            let steps = namespace.split('.');
            for (let i = 0; i < steps.length; i++) {
                if (i === steps.length - 1) {
                    path[steps[i]] = payload
                } else {
                    path[steps[i]] = {}
                }
                path = path[steps[i]]
            }

            payload = finalPath
        }

        context.commit('NAMESPACE', payload);
    }
}
